module.exports = __webpack_public_path__ + "static/img/torso15.1c68a8aa.jpg";